export function formatCnpj(cnpj?: string | null): string | null {
  if (!cnpj) return null;
  const d = cnpj.replace(/\D/g, '');
  if (d.length !== 14) return cnpj;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
}

export function formatCpf(cpf?: string | null): string | null {
  if (!cpf) return null;
  const d = cpf.replace(/\D/g, '');
  if (d.length !== 11) return cpf;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
}

export function normalizeCpf(cpf?: string | null): string {
  return cpf?.replace(/\D/g, '') ?? '';
}

export function isValidCpf(cpf?: string | null): boolean {
  const d = normalizeCpf(cpf);
  if (d.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(d)) return false;

  const checkDigit = (length: number) => {
    let sum = 0;
    for (let i = 0; i < length; i += 1) {
      sum += Number(d[i]) * (length + 1 - i);
    }
    const rest = (sum * 10) % 11;
    return rest === 10 ? 0 : rest;
  };

  return checkDigit(9) === Number(d[9]) && checkDigit(10) === Number(d[10]);
}

// Render a masked CPF/CNPJ given only its last-4 digits.
// The backend never sends the full document to the client (PII protection).
//   CPF  → "***.***.***-89"  (last 2 visible)
//   CNPJ → "**.***.***\/****-89"
export function maskFromLast4(last4?: string | null, type?: string | null): string | null {
  if (!last4) return null;
  const d = last4.replace(/\D/g, '');
  if (d.length < 2) return null;
  const last2 = d.slice(-2);
  if (type === 'CPF') return `***.***.***-${last2}`;
  if (type === 'CNPJ') return `**.***.***/****-${last2}`;
  return `••••${d}`;
}

/**
 * Format a boleto digitable line into the canonical 5/5/5/6/1/14 grouping:
 *   12345.67890 12345.678901 12345.678901 1 23456789012345
 */
export function formatDigitableLine(line?: string | null): string | null {
  if (!line) return null;
  const d = line.replace(/\D/g, '');
  if (d.length !== 47) return line;
  return [
    `${d.slice(0, 5)}.${d.slice(5, 10)}`,
    `${d.slice(10, 15)}.${d.slice(15, 21)}`,
    `${d.slice(21, 26)}.${d.slice(26, 32)}`,
    d.slice(32, 33),
    d.slice(33, 47),
  ].join(' ');
}
